module.exports = __webpack_public_path__ + "img/lingbomanager_login_img@3x.fa095f99.png";